"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 -1 33 33';

var EllipsisCircle = function EllipsisCircle(_ref) {
  var classes = _ref.classes;
  return _react["default"].createElement("g", null, _react["default"].createElement("circle", {
    cx: "16",
    cy: "16",
    r: "16"
  }), _react["default"].createElement("path", {
    className: classes.ellipsis,
    transform: "translate(10, 15)",
    d: "M1.95,0.5 C1.1525,0.5 0.5,1.1525 0.5,1.9495 C0.5,2.747 1.1525,3.4 1.95,3.4 C2.7475,3.4 3.3995,2.747 3.3995,1.9495 C3.3995,1.1525 2.7475,0.5 1.95,0.5 Z M10.6485,0.5 C9.8515,0.5 9.199,1.1525 9.199,1.9495 C9.199,2.747 9.8515,3.4 10.6485,3.4 C11.446,3.4 12.0985,2.747 12.0985,1.9495 C12.0985,1.1525 11.446,0.5 10.6485,0.5 Z M6.299,0.5 C7.097,0.5 7.7495,1.1525 7.7495,1.9495 C7.7495,2.747 7.097,3.4 6.299,3.4 C5.502,3.4 4.8495,2.747 4.8495,1.9495 C4.8495,1.1525 5.502,0.5 6.299,0.5 Z"
  }));
};

EllipsisCircle.propTypes = {
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired
};
var StyledEllipsisCircle = (0, _withStyles["default"])({
  ellipsis: {
    fill: _styles.colors.white
  }
})(EllipsisCircle);

var _default = (0, _createSvgIcon["default"])(StyledEllipsisCircle, {
  viewBox: viewBox
});

exports["default"] = _default;